<template>
  <div>
    <div class="banner-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-7 col-md-12" data-aos="fade-right">
            <div class="banner-content">
              <div class="content">
                <div class="banner-content-slides">
                  <carousel
                    :autoplay="5000"
                    :wrap-around="true"
                    :settings="settings"
                  >
                    <slide v-for="slide in carouselItems" :key="slide.id">
                      <div class="inner-content plr-15">
                        <h1>{{ slide.heading }}</h1>
                        <p>{{ slide.description }}</p>

                        <router-link :to="slide.btnLink" class="btn-benovium">
                          <i class="bx bxs-hot"></i>
                          {{ slide.btnText }}
                        </router-link>
                      </div>
                    </slide>

                    <template #addons>
                      <Navigation />
                    </template>
                  </carousel>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-5 col-md-12">
            <div class="banner-img banner-video">
              <div class="d-table">
                <div class="d-table-cell">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<!-- 
      <div class="shape19">
        <img src="../../assets/img/shape/18.png" alt="image" />
      </div>
      <div class="shape22">
        <img src="../../assets/img/shape/21.png" alt="image" />
      </div>
      <div class="shape23">
        <img src="../../assets/img/shape/22.svg" alt="image" />
      </div>
      <div class="shape24">
        <img src="../../assets/img/shape/23.png" alt="image" />
      </div>
      <div class="shape25">
        <img src="../../assets/img/shape/24.png" alt="image" />
      </div>
      <div class="shape26">
        <img src="../../assets/img/shape/25.png" alt="image" />
      </div>
      <div class="shape20">
        <img src="../../assets/img/shape/19.png" alt="image" />
      </div> -->
    </div>
    <div class="popup-video" v-if="isPopup">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="popup-overlay-close" v-on:click="isPopupMethod(isPopup)">
            <div class="popup-overlay-close-line"></div>
            <div class="popup-overlay-close-line"></div>
          </div>
          <div class="play-video">
            <iframe src="https://www.youtube.com/embed/bk7McNUjWgw"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "MainBanner",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    isPopup: false,
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    carouselItems: [
      {
        id: 1,
        heading: "Web- und Mobile-App-Entwicklung",
        description:
          "Wir entwickeln maßgeschneiderte Web- und Mobile-Anwendungen, die Ihre Geschäftsprozesse optimieren und Ihre Kunden begeistern. Mit modernsten Technologien setzen wir Ihre Visionen in die Realität um.",
        btnText: "Kontakt aufnehmen",
        btnLink: "/contact",
      },
      {
        id: 2,
        heading: "Geschäftliche Herausforderungen mit IT lösen",
        description:
          "Unsere erfahrenen IT-Experten analysieren Ihre Anforderungen und entwickeln individuelle Lösungen, die Ihr Unternehmen voranbringen. Profitieren Sie von unserer Expertise und Innovation.",
        btnText: "Kontakt aufnehmen",
        btnLink: "/contact",
      },
    ],
  }),
  methods: {
    isPopupMethod(isPopup) {
      return (this.isPopup = !isPopup);
    },
  },
});
</script>
